import React, { Fragment } from 'react';
import {
  Intro,
  Button,
  Scoreboard,
  ReviewSheet,
  Accordion,
  ModuleFeedback
} from 'abbot-core';
import certFile from '../../assets/certificate/certificate.pdf';
import img from '../../assets/images/U1-T2-5-1.svg';

// We do use noopener in the link below, but jsx-no-target-blank also demands noreferrer for older browsers which we haven't set
/* eslint-disable react/jsx-no-target-blank */

const data = {
  title: 'Review Answer Sheet',
  content: <ReviewSheet />
};
// {
//   title: 'Explore Additional Modules',
//   content: (
//     <Fragment>
//       <p>
//         <strong>Pathway to Financial Success</strong>
//         <br />
//         Empower high school students to take control of their financial futures.
//         Educators can help students and their families explore comprehensive
//         financial literacy resources to gain the tools and skills they need to
//         make sound financial decisions and achieve their personal goals.<br />
//         <a
//           href="https://www.pathwayinschools.com/"
//           rel="noopener"
//           target="_blank"
//         >
//           www.pathwayinschools.com
//         </a>
//       </p>
//     </Fragment>
//   )
// }

const moduleFeedbackData = {
  badgeThreshold: 5,
  badgeSuccess: (
    <Fragment>
      <p className="scoreboard">
        Congratulations! You have earned enough points to get a certificate!
      </p>
      <Button
        classes={{ 'cert-download': true }}
        children="Download Certificate"
        file={certFile}
      />
    </Fragment>
  ),
  badgeFailure: (
    <p className="scoreboard">
      Still want to earn a certificate? Try the module again to see if you can
      increase your score.
    </p>
  )
};

/* eslint-enable react/jsx-no-target-blank */

export default {
  title: 'Complete',
  path: '/complete',
  content: (
    <Fragment>
      <Intro
        title="Results and Certificate of Completion"
        lead="Congratulations on completing the Nutritious Eating module."
        img={img}
      />

      <div className="abbott-completion">
        <Scoreboard />

        {/*<Button*/}
        {/*  classes={{ 'cert-download': true }}*/}
        {/*  children="Download Certificate"*/}
        {/*  file={certFile}*/}
        {/*/>*/}
      </div>

      <div className="abbott-completion">
        <ModuleFeedback data={moduleFeedbackData} />
      </div>

      <Accordion data={data} />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/certificate/Complete.js